import { render } from "./CorporateRequestsPage.vue?vue&type=template&id=01937b27&scoped=true"
import script from "./CorporateRequestsPage.vue?vue&type=script&lang=js"
export * from "./CorporateRequestsPage.vue?vue&type=script&lang=js"

import "./CorporateRequestsPage.vue?vue&type=style&index=0&id=01937b27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01937b27"]])

export default __exports__